import { locale as english } from './en';
import { locale as spanish } from './es';
import { locale as turkish } from './tr';
import { locale as zh1 } from './zh1';
import { locale as zh2 } from './zh2';
import { locale as pt } from './pt';
import { locale as de } from './de';
import { locale as nl } from './nl';

//export const lang_configuracion = FuseTranslationLoaderService.loadTranslations(english, spanish);

export const lang_confirmaEncu = [english, spanish, turkish, zh1, zh2, pt, de, nl];
